/* Toggle body.cart-drawer-open in lockstep with the cart drawer's OWN open/close state, so the
   custom bottom mobile nav can be hidden (CSS) while the drawer is open — letting the Checkout
   button be fully tappable. We mirror the drawer's state by observing the 'active' class that
   Dawn's CartDrawer adds on open() and removes on close() — so EVERY close path (X, backdrop,
   Escape, programmatic) re-shows the nav, and there's no separate listener to desync.
   External asset (not inline) so the homepage perf-tool can't strip it. */
(function () {
  'use strict';
  function sync() {
    var cd = document.querySelector('cart-drawer');
    var open = !!(cd && cd.classList.contains('active'));
    document.body.classList.toggle('cart-drawer-open', open);
  }
  function init() {
    var cd = document.querySelector('cart-drawer');
    if (!cd) return;
    sync();
    try {
      new MutationObserver(sync).observe(cd, { attributes: true, attributeFilter: ['class'] });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('pageshow', sync);   /* bfcache restore → re-sync, never stuck hidden */
})();
